import { getChannelContextCode, getChannelContextMsg } from 'helpers/Utility';
import { setError } from 'store/actions/auth';

export const handleWhitelistError = (dispatch, err) => {
  if (!err.response) {
    return dispatch(setError('connection'));
  }

  const errorMap = {
    1003: 'failed_insert',
    null: 'system'
  };

  if (
    getChannelContextCode(err, 'channel-context') === '1004' &&
    getChannelContextMsg(err, 'channel-context').includes('file already exist')
  ) {
    return dispatch(setError('failed_insert'));
  }

  if (errorMap[getChannelContextCode(err, 'channel-context')]) {
    return dispatch(
      setError(errorMap[getChannelContextCode(err, 'channel-context')])
    );
  }

  if (err.response.status === 422) {
    return dispatch(setError('miss_match'));
  }
};
